import { requiredMessage } from 'validation'
import * as yup from 'yup'

export const CHANGE_PASSWORD_SCHEMA = yup.object().shape({
  password: yup.string().trim().required(requiredMessage),
})